import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import TextField from '@material-ui/core/TextField';
import { WorkerCapturedAuditReportSundryObject } from '../WorkerCapturedAuditReportSundrySchema';
import { validateProperty, validate } from "../../../Common";
import divisionService from '../../../Devision/services';
import groupService from '../../../Group/services';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import './tableFooter.css';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { InputAdornment, Box } from '@material-ui/core';
import Search from '@mui/icons-material/Search';

const screenCode = 'WORKERCAPTUREDAUDITREPORTSUNDRY';

export function WorkerCapturedAuditReportSundryListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [divisions, setDivisions] = useState();
    const [fields, setFields] = useState([]);
    const [errors, setErrors] = useState({});
    const [auditRows, setAuditRows] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [capturingPercentages, setCapturingPercentages] = useState({
        general_manual: 0,
        general_qr: 0,
        general_face: 0,
        cash_manual: 0,
        cash_qr: 0,
        cash_face: 0,
        overtime_manual: 0,
        overtime_qr: 0,
        overtime_face: 0
    });
    const schema = Joi.object(WorkerCapturedAuditReportSundryObject).options({ allowUnknown: true })
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);

    const today = new Date().toISOString().slice(0, 10);
    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            mode: "0",
            fromDate: today,
            toDate: today
        }
    );

    const [isTableHide, setIsTableHide] = useState(true);
    const [noDataWarning, setNoDataWarning] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        feild: "",
        mode: "",
        fromDate: "",
        toDate: ""
    })
    const printPageStyle = `
        @page { size: A4 landscape; margin: 12mm; }
        @media print {
            #summaryReportPdf { width: 100%; border-collapse: collapse !important; border-spacing: 0 !important; }
            #summaryReportPdf td, #summaryReportPdf th {
                border: 0.5mm solid #000 !important;
                box-shadow: none !important;
            }
            #summaryReportPdf { border: 0.5mm solid #000 !important; box-shadow: none !important; }
        }
    `;

    const resetCapturingPercentages = {
        general_manual: 0,
        general_qr: 0,
        general_face: 0,
        cash_manual: 0,
        cash_qr: 0,
        cash_face: 0,
        overtime_manual: 0,
        overtime_qr: 0,
        overtime_face: 0
    };

    const possibleKeys = [
        'general_manual', 'general_qr', 'general_face',
        'cash_manual', 'cash_qr', 'cash_face',
        'overtime_manual', 'overtime_qr', 'overtime_face'
    ];

    const getSafe = (value, fallback = "-") => {
        if (value === null || value === undefined) return fallback;
        if (typeof value === 'string' && value.trim() === '') return fallback;
        return value;
    }

    const normalizeJobType = (row) => {
        const raw = (row?.JobType ?? row?.jobTypeID ?? row?.jobType ?? row?.jobTypeName ?? row?.narration ?? row?.type ?? row?.jobTypeCode);
        if (raw === null || raw === undefined) return null;

        const rawNum = Number(raw);
        const rawStr = String(raw).toUpperCase();
        if (rawNum === 1 || rawStr.includes('GENERAL')) return 'general';
        if (rawNum === 2 || rawStr.includes('CASH')) return 'cash';
        if (rawNum === 3 || rawStr.includes('OT') || rawStr.includes('OVER')) return 'overtime';
        return null;
    }

    const normalizeMode = (row, rawOverride = undefined) => {
        const raw = (rawOverride ?? row?.VerificationMethod ?? row?.verificationMethod ?? row?.pluckingType ?? row?.mode ?? row?.captureMode ?? row?.biometricTypeID ?? row?.scanType ?? row?.modeID);
        if (raw === null || raw === undefined) return null;

        const rawNum = Number(raw);
        const rawStr = String(raw).toUpperCase();

        if (rawNum === 0) return null;
        if (rawNum === 6 || rawStr.includes('MANUAL')) return 'manual';
        if (rawNum === 3 || rawStr === 'QR') return 'qr';
        if (rawNum === 1 || rawStr.includes('FACE')) return 'face';
        if (rawNum === 2) return 'qr';
        return null;
    }

    const getCaptureKey = (row, modeRawOverride = undefined) => {
        const jobType = normalizeJobType(row);
        const mode = normalizeMode(row, modeRawOverride);
        if (!jobType || !mode) return null;
        return `${jobType}_${mode}`;
    }

    const parseToDate = (value) => {
        if (value === null || value === undefined) return null;
        if (value instanceof Date) return isNaN(value.getTime()) ? null : value;

        const asString = String(value);
        const d = new Date(asString);
        return isNaN(d.getTime()) ? null : d;
    }

    const getTick = (isTick) => isTick
        ? <span style={{ color: "#2e7d32", fontWeight: "bold", fontSize: "18px", lineHeight: 1, display: "inline-block" }}>✔</span>
        : null;

    const getExcelTick = (isTick) => (isTick ? "✔" : "");

    const getRowDate = (row) => {
        const val =
            (row?.StartTime ?? row?.startTime ?? row?.date ?? row?.searchDate ?? row?.createdDate ?? row?.workDate ?? row?.pluckingDate) ??
            (row?.EndTime ?? row?.endTime ?? row?.endDate ?? row?.EndDate ?? row?.endDateTime);
        return getSafe(val);
    }

    const getEmpNo = (row) => getSafe(row.employeeCode);
    const getEmpName = (row) => getSafe(row.firstName);
    const getJobCode = (row) => getSafe(row.jobCode);
    const getWorkedDivision = (row) => getSafe(
        row.division ?? row.Division ?? row.divisionName ?? row.DivisionName ??
        row.workedDivision ?? row.workedDivisionName ?? row.collectionPointName ?? row.collectionPoint
    );
    const getFieldName = (row) => getSafe(row.fieldName ?? row.Field_name ?? row.field);
    const getOperator = (row) => getSafe(
        row.operator ?? row.Operator ?? row.oparator ?? row.operatorName ??
        row.OperatorName ?? row.oparatorName ?? row.createdBy ?? row.userName ?? row.createdUser
    );

    const getVerificationMethod = (row, kind) => {
        if (kind === 'completed') {
            return (
                row?.EndVerificationMethod ?? row?.endVerificationMethod ??
                row?.endVerificationMode ?? row?.endMode ??
                row?.EndVerification ?? row?.endVerification
            );
        }
        return (
            row?.StartVerificationMethod ?? row?.startVerificationMethod ??
            row?.startVerificationMode ?? row?.startMode ??
            row?.StartVerification ?? row?.startVerification ??
            row?.VerificationMethod ?? row?.verificationMethod
        );
    }

    const hasCompletedEvent = (row) => {
        const endTimeVal = row?.EndTime ?? row?.endTime ?? row?.endDate ?? row?.EndDate ?? row?.endDateTime;
        return !!parseToDate(endTimeVal);
    }

    const getStartEndKeys = (row) => {
        const startMethod = getVerificationMethod(row, 'start');
        const startKey = getCaptureKey(row, startMethod);

        if (!hasCompletedEvent(row)) return { startKey, endKey: null };

        const endMethod = getVerificationMethod(row, 'completed');
        const endKey = getCaptureKey(row, endMethod);
        return { startKey, endKey };
    }

    const hasTick = (row, status, key) => {
        const method = getVerificationMethod(row, status);
        const mode = normalizeMode(row, method);
        if (!mode) return false;

        if (status === 'completed' && !hasCompletedEvent(row)) return false;

        const parts = key.split('_');
        const targetJobType = parts[0];
        const targetMode = parts[1];

        if (mode !== targetMode) return false;

        const baseJobType = normalizeJobType(row);

        return baseJobType === targetJobType;
    }

    const filterAuditRows = (rows, text) => {
        if (!text.trim()) return rows;
        const lower = text.trim().toLowerCase();
        return (rows ?? []).filter(row => {
            const searchableValues = [
                getEmpNo(row),
                getEmpName(row),
                getJobCode(row),
                getWorkedDivision(row),
                getFieldName(row),
                getOperator(row)
            ];
            return searchableValues.some(value => value !== "-" && value.toString().toLowerCase().includes(lower));
        });
    }

    const computeCapturingPercentages = (rows) => {
        const keysForPercent = [];
        (rows ?? []).forEach(r => {
            possibleKeys.forEach(k => {
                if (hasTick(r, 'start', k)) keysForPercent.push(k);
                if (hasTick(r, 'completed', k)) keysForPercent.push(k);
            });
        });

        const total = keysForPercent.length;
        const counts = { ...resetCapturingPercentages };

        keysForPercent.forEach(key => {
            if (counts[key] !== undefined) counts[key] = counts[key] + 1;
        });

        const percents = {};
        Object.keys(counts).forEach(k => {
            percents[k] = total > 0 ? Math.round((counts[k] * 100) / total) : 0;
        });
        return percents;
    }

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(setGroupDropDownData())
    }, []);

    useEffect(() => {
        trackPromise(getEsatesForDropDown())
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(GetDivisionForDropDown())
    }, [searchForm.estateID]);

    useEffect(() => {
        trackPromise(getFeildsByCollectionPoint())
    }, [searchForm.divisionID]);

    useEffect(() => {
        let timer;
        if (noDataWarning) {
            timer = setTimeout(() => {
                setNoDataWarning(false);
            }, 3000);
        }
        return () => clearTimeout(timer);
    }, [noDataWarning]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWWORKERCAPTUREDAUDITREPORTSUNDRY');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {
            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray);
            setSearchForm({
                ...searchForm,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        } else {
            setSearchForm({
                ...searchForm,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await groupService.getGroupsForDropdown();
        setGroups(result);
    }

    async function getEsatesForDropDown() {
        const factoryList = await divisionService.getEstatesByGroupID(searchForm.groupID);
        const token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities && token.operationEntities.length > 0) {
            const validEstateIds = token.operationEntities.map(entity => String(entity.OperationEntityID));
            const filteredEstates = {};
            for (const [key, value] of Object.entries(factoryList)) {
                if (validEstateIds.includes(String(key))) {
                    filteredEstates[key] = value;
                }
            }
            setEstates(filteredEstates);
            //setMultipleEstates(filteredEstates);
        } else {
            setEstates(factoryList);
            setMultipleEstates([]);
        }
    }

    async function GetDivisionForDropDown() {
        const routeList = await services.GetDivisionByEstateID(searchForm.estateID);
        setDivisions(routeList);
    }

    async function getFeildsByCollectionPoint() {
        if (searchForm.divisionID === "0") {
            setFields([]);
            return;
        }
        const data = await services.GetFieldsByCollectionPoint(searchForm.divisionID);
        setFields(data);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function getLabelFromSource(source, key, fallback = "") {
        if (key === null || key === undefined) return fallback;
        if (!source) return fallback;

        if (source[key] !== undefined && source[key] !== null && typeof source[key] !== 'object') {
            return source[key];
        }

        if (!Array.isArray(source) && typeof source === 'object') {
            return source[key] ?? fallback;
        }

        if (Array.isArray(source)) {
            const keyStr = String(key);
            const match = source.find(x =>
                x && String(x?.key ?? x?.id ?? x?.value ?? x?.fieldID ?? x?.divisionID ?? x?.estateID ?? x?.groupID) === keyStr
            );
            return match?.label ?? match?.name ?? match?.fieldName ?? match?.divisionName ?? match?.estateName ?? match?.groupName ?? fallback;
        }

        return fallback;
    }

    function getSelectedDropdownValuesForReport(form) {
        const modeLabel =
            form.mode === "6" ? "Manual" :
                form.mode === "3" ? "QR" :
                    form.mode === "1" ? "Face ID" :
                        "All (Optional)";

        setSelectedSearchValues({
            group: getLabelFromSource(groups, form.groupID, ""),
            estate: getLabelFromSource(estates, form.estateID, ""),
            division: form.divisionID === "0" ? "All (Optional)" : getLabelFromSource(divisions, form.divisionID, ""),
            feild: form.fieldID === "0" ? "All (Optional)" : getLabelFromSource(fields, form.fieldID, ""),
            mode: modeLabel,
            fromDate: form.fromDate,
            toDate: form.toDate
        });
    }

    function clearTableRelatedData() {
        setAuditRows([]);
        setSearchText("");
        setCapturingPercentages(resetCapturingPercentages);
        setIsReportButtonsEnabled(false);
        setIsTableHide(true);
        setNoDataWarning(false);
    }

    function handleGroupChange(target) {
        validateInputs(target);
        clearTableRelatedData();
        setSearchForm({ ...searchForm, groupID: target.value, estateID: "0", divisionID: "0", fieldID: "0" });
    }

    function handleEstateChange(target) {
        validateInputs(target);
        clearTableRelatedData();
        setSearchForm({
            ...searchForm,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0",
            mode: "0",
            fromDate: today,
            toDate: today
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);
        clearTableRelatedData();
        setSearchForm({
            ...searchForm,
            divisionID: target.value,
            fieldID: "0",
            mode: "0",
            fromDate: today,
            toDate: today
        });
    }

    function handleModeChange(target) {
        validateInputs(target);
        clearTableRelatedData();
        setSearchForm({ ...searchForm, mode: target.value });
    }

    function handleFromDateChange(target) {
        validateInputs(target);
        clearTableRelatedData();
        setSearchForm({ ...searchForm, fromDate: target.value });
    }

    function handleToDateChange(target) {
        validateInputs(target);
        clearTableRelatedData();
        setSearchForm({ ...searchForm, toDate: target.value });
    }

    function handleFieldChange(target) {
        validateInputs(target);
        clearTableRelatedData();
        setSearchForm({ ...searchForm, fieldID: target.value });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, WorkerCapturedAuditReportSundryObject);
        errorMessage ? (error[target.name] = errorMessage) : delete error[target.name];
        setErrors(error);
    }

    const getFormattedRowDate = (row) => {
        const val =
            (row?.StartTime ?? row?.startTime ?? row?.date ?? row?.searchDate ?? row?.createdDate ?? row?.workDate ?? row?.pluckingDate) ??
            (row?.EndTime ?? row?.endTime ?? row?.endDate ?? row?.EndDate ?? row?.endDateTime);
        if (!val || val === '-') return { date: '-', time: '-' };

        try {
            const dateObj = new Date(val);
            if (isNaN(dateObj.getTime())) {
                const parts = String(val).split(/[ T]/);
                return {
                    date: parts[0] || val,
                    time: parts[1] || '-'
                };
            }
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            const dd = String(dateObj.getDate()).padStart(2, '0');
            const dateStr = `${yyyy}-${mm}-${dd}`;

            let hours = dateObj.getHours();
            const minutes = String(dateObj.getMinutes()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            const timeStr = `${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;

            return { date: dateStr, time: timeStr };
        } catch (e) {
            return { date: val, time: '-' };
        }
    }

    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(true);
        setNoDataWarning(false);
        setSearchText("");

        const errorMessages = validate(schema, searchForm)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(searchForm);
        var reportData = await services.GetWorkerCapturedAuditData(searchForm);

        const rows = Array.isArray(reportData)
            ? reportData
            : (reportData?.weighReportsData ?? reportData?.data ?? reportData?.rows ?? []);

        setAuditRows(rows);
        setCapturingPercentages(computeCapturingPercentages(rows));

        if (rows && rows.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
            setNoDataWarning(false);
        } else {
            setIsTableHide(true);
            setIsReportButtonsEnabled(false);
            setNoDataWarning(true);
        }
    }

    function handleClear() {
        setSearchForm(prev => ({
            ...prev,
            divisionID: "0",
            fieldID: "0",
            mode: "0",
            fromDate: today,
            toDate: today
        }));
        setErrors({});
        clearTableRelatedData();
    }

    const rowSpanCellStyle = { verticalAlign: "middle" };

    const filteredAuditRows = filterAuditRows(auditRows, searchText);
    const displayPercentages = computeCapturingPercentages(filteredAuditRows);

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div className="card">
                        <PageHeader title="Worker Captured Audit Report - Sundry" />
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                        <div className="row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="groupID">Group *</InputLabel>
                                                <Select
                                                    fullWidth
                                                    id="groupID"
                                                    disabled={!permissionList.isGroupFilterEnabled}
                                                    name="groupID"
                                                    value={searchForm.groupID}
                                                    onChange={(e) => handleGroupChange(e.target)}>
                                                    <MenuItem value="0">--Select Group--</MenuItem>
                                                    {generateDropDownMenu(groups)}
                                                </Select>
                                                {errors["groupID"] && <FormHelperText id="errgroupID" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                                <Select
                                                    fullWidth
                                                    id="estateID"
                                                    name="estateID"
                                                    disabled={!permissionList.isOperationEntityFilterEnabled}
                                                    value={searchForm.estateID}
                                                    onChange={(e) => handleEstateChange(e.target)}>
                                                    <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                                    {generateDropDownMenu(multipleEstates.length === 0 ? estates : multipleEstates)}
                                                </Select>
                                                {errors["estateID"] && <FormHelperText id="errestateID" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="divisionID">Collection Point</InputLabel>
                                                <Select
                                                    fullWidth
                                                    id="divisionID"
                                                    name="divisionID"
                                                    value={searchForm.divisionID}
                                                    onChange={(e) => handleDivisionChange(e.target)}>
                                                    <MenuItem value="0">--Select Collection Point--</MenuItem>
                                                    {generateDropDownMenu(divisions)}
                                                </Select>
                                                {errors["divisionID"] && <FormHelperText id="errdivisionID" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1 mr-3">
                                                <InputLabel shrink id="fieldID">Field</InputLabel>
                                                <Select
                                                    fullWidth
                                                    id="fieldID"
                                                    name="fieldID"
                                                    value={searchForm.fieldID}
                                                    onChange={(e) => handleFieldChange(e.target)}>
                                                    <MenuItem value="0">--All Field--</MenuItem>
                                                    {generateDropDownMenu(fields)}
                                                </Select>
                                                {errors["fieldID"] && <FormHelperText id="errfieldID" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="mode">Mode</InputLabel>
                                                <Select
                                                    fullWidth
                                                    id="mode"
                                                    name="mode"
                                                    value={searchForm.mode}
                                                    onChange={(e) => handleModeChange(e.target)}>
                                                    <MenuItem value="0">--All Modes--</MenuItem>
                                                    <MenuItem value="6">Manual</MenuItem>
                                                    <MenuItem value="3">QR</MenuItem>
                                                    <MenuItem value="1">Face ID</MenuItem>
                                                </Select>
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="fromDate"
                                                    name="fromDate"
                                                    type="date"
                                                    value={searchForm.fromDate}
                                                    onChange={(e) => handleFromDateChange(e.target)}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{ max: today }}
                                                />
                                                {errors["fromDate"] && <FormHelperText id="errfromDate" className="text text-danger">{errors["fromDate"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1 mr-3">
                                                <InputLabel shrink id="toDate">To Date *</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="toDate"
                                                    name="toDate"
                                                    type="date"
                                                    value={searchForm.toDate}
                                                    onChange={(e) => handleToDateChange(e.target)}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                {errors["toDate"] && <FormHelperText id="errtoDate" className="text text-danger">{errors["toDate"]}</FormHelperText>}
                                            </div>
                                        </div>

                                        <input
                                            type="submit"
                                            className="btn btn-primary mr-3"
                                            value="Generate"
                                        />
                                        <input
                                            type="reset"
                                            className="btn btn-warning pull-right"
                                            value="Clear"
                                            onClick={handleClear}
                                        />
                                    </form>
                                    {noDataWarning && (
                                        <div className="alert alert-warning" role="alert" style={{ marginTop: '15px' }}>
                                            No records found.
                                        </div>
                                    )}
                                </div>

                                <div className="w-100"></div>
                                <div className="col pl-5">
                                    {isTableHide ? null :
                                        <div>
                                            <Box display="flex" flexDirection="row-reverse" p={2}>
                                                <TextField
                                                    size="small"
                                                    style={{ width: '300px' }}
                                                    value={searchText}
                                                    placeholder="Search"
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Search />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                            <div>
                                                {/* ── MAIN DISPLAY TABLE ── */}
                                                <table
                                                    id="summaryReport"
                                                    className="display dataTable no-footer"
                                                    style={{
                                                        display: "block",
                                                        overflowX: "auto",
                                                        whiteSpace: "nowrap",
                                                        maxWidth: "1400px",
                                                        borderColor: "white"
                                                    }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th rowSpan={2}>Date</th>
                                                            <th rowSpan={2}>Emp No</th>
                                                            <th rowSpan={2}>Emp Name</th>
                                                            <th rowSpan={2}>Job Code</th>
                                                            <th rowSpan={2}>Collection Point</th>
                                                            <th rowSpan={2}>Field</th>
                                                            <th rowSpan={2}>Oparator</th>
                                                            <th rowSpan={2}>Status</th>
                                                            <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan={3}>General</th>
                                                            <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan={3}>Cash</th>
                                                            <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan={3}>Over Time</th>
                                                        </tr>
                                                        <tr>
                                                            <th style={{ textAlign: "center" }}>Manual</th>
                                                            <th style={{ textAlign: "center" }}>QR</th>
                                                            <th style={{ textAlign: "center" }}>Face ID</th>
                                                            <th style={{ textAlign: "center" }}>Manual</th>
                                                            <th style={{ textAlign: "center" }}>QR</th>
                                                            <th style={{ textAlign: "center" }}>Face ID</th>
                                                            <th style={{ textAlign: "center" }}>Manual</th>
                                                            <th style={{ textAlign: "center" }}>QR</th>
                                                            <th style={{ textAlign: "center" }}>Face ID</th>
                                                        </tr>
                                                    </thead>
                                                    <tfoot>
                                                        <tr>
                                                            <th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={8}>Capturing Percentages</th>
                                                            <th style={{ textAlign: "center" }}>{displayPercentages.general_manual}%</th>
                                                            <th style={{ textAlign: "center" }}>{displayPercentages.general_qr}%</th>
                                                            <th style={{ textAlign: "center" }}>{displayPercentages.general_face}%</th>
                                                            <th style={{ textAlign: "center" }}>{displayPercentages.cash_manual}%</th>
                                                            <th style={{ textAlign: "center" }}>{displayPercentages.cash_qr}%</th>
                                                            <th style={{ textAlign: "center" }}>{displayPercentages.cash_face}%</th>
                                                            <th style={{ textAlign: "center" }}>{displayPercentages.overtime_manual}%</th>
                                                            <th style={{ textAlign: "center" }}>{displayPercentages.overtime_qr}%</th>
                                                            <th style={{ textAlign: "center" }}>{displayPercentages.overtime_face}%</th>
                                                        </tr>
                                                    </tfoot>
                                                    <tbody>
                                                        {filteredAuditRows.length > 0 ? filteredAuditRows.map((r, idx) => {
                                                            return (
                                                                <Fragment key={idx}>
                                                                    {/* START row */}
                                                                    <tr>
                                                                        <td rowSpan={2} style={rowSpanCellStyle}>
                                                                            <div>{getFormattedRowDate(r).date}</div>
                                                                            <div style={{ fontSize: '11px', color: '#555' }}>{getFormattedRowDate(r).time}</div>
                                                                        </td>
                                                                        <td rowSpan={2} style={rowSpanCellStyle}>{getEmpNo(r)}</td>
                                                                        <td rowSpan={2} style={rowSpanCellStyle}>{getEmpName(r)}</td>
                                                                        <td rowSpan={2} style={rowSpanCellStyle}>{getJobCode(r)}</td>
                                                                        <td rowSpan={2} style={rowSpanCellStyle}>{getWorkedDivision(r)}</td>
                                                                        <td rowSpan={2} style={rowSpanCellStyle}>{getFieldName(r)}</td>
                                                                        <td rowSpan={2} style={rowSpanCellStyle}>{getOperator(r)}</td>
                                                                        <td>Start</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'start', 'general_manual'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'start', 'general_qr'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'start', 'general_face'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'start', 'cash_manual'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'start', 'cash_qr'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'start', 'cash_face'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'start', 'overtime_manual'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'start', 'overtime_qr'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'start', 'overtime_face'))}</td>
                                                                    </tr>
                                                                    {/* COMPLETED row */}
                                                                    <tr>
                                                                        <td>Completed</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'completed', 'general_manual'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'completed', 'general_qr'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'completed', 'general_face'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'completed', 'cash_manual'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'completed', 'cash_qr'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'completed', 'cash_face'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'completed', 'overtime_manual'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'completed', 'overtime_qr'))}</td>
                                                                        <td style={{ textAlign: "center" }}>{getTick(hasTick(r, 'completed', 'overtime_face'))}</td>
                                                                    </tr>
                                                                </Fragment>
                                                            );
                                                        }) :
                                                            <tr>
                                                                <td colSpan={17} style={{ textAlign: "center" }}>No records found</td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>

                                            {!isReportButtonsEnabled ? null :
                                                <div className="pt-2 mr-2">
                                                    <ReactToPrint
                                                        documentTitle={"Worker Captured Audit Report - Sundry"}
                                                        pageStyle={printPageStyle}
                                                        trigger={() => <input
                                                            type="button"
                                                            className="btn btn-primary pull-right ml-2"
                                                            value="PDF"
                                                        />}
                                                        content={() => componentRef.current}
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePdf
                                                            ref={componentRef}
                                                            rows={auditRows}
                                                            capturingPercentages={capturingPercentages}
                                                            searchData={selectedSearchValues}
                                                        />
                                                    </div>

                                                    {/* ── HIDDEN EXCEL TABLE ── */}
                                                    <table id="worker-captured-audit-xls" hidden={true} border="1" style={{ borderCollapse: "collapse" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={4}><b>Group : </b>{selectedSearchValues.group}</td>
                                                                <td colSpan={4}><b>Operation Entity : </b>{selectedSearchValues.estate}</td>
                                                                <td colSpan={5}><b>Collection Point : </b>{selectedSearchValues.division === undefined ? "All (Optional)" : selectedSearchValues.division}</td>
                                                                <td colSpan={4}><b>Mode : </b>{selectedSearchValues.mode}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={5}><b>Field : </b>{selectedSearchValues.feild === undefined ? "All (Optional)" : selectedSearchValues.feild}</td>
                                                                <td colSpan={6}><b>From Date : </b>{selectedSearchValues.fromDate}</td>
                                                                <td colSpan={6}><b>To Date : </b>{selectedSearchValues.toDate}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={17}>&nbsp;</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={17} style={{ fontWeight: "bold" }}>Daily Tasks</td>
                                                            </tr>
                                                            <tr>
                                                                <th rowSpan={2}>Date</th>
                                                                <th rowSpan={2}>Emp No</th>
                                                                <th rowSpan={2}>Emp Name</th>
                                                                <th rowSpan={2}>Job Code</th>
                                                                <th rowSpan={2}>Collection Point</th>
                                                                <th rowSpan={2}>Field</th>
                                                                <th rowSpan={2}>Oparator</th>
                                                                <th rowSpan={2}>Status</th>
                                                                <th colSpan={3} style={{ textAlign: "center" }}>General</th>
                                                                <th colSpan={3} style={{ textAlign: "center" }}>Cash</th>
                                                                <th colSpan={3} style={{ textAlign: "center" }}>Over Time</th>
                                                            </tr>
                                                            <tr>
                                                                <th style={{ textAlign: "center" }}>Manual</th>
                                                                <th style={{ textAlign: "center" }}>QR</th>
                                                                <th style={{ textAlign: "center" }}>Face ID</th>
                                                                <th style={{ textAlign: "center" }}>Manual</th>
                                                                <th style={{ textAlign: "center" }}>QR</th>
                                                                <th style={{ textAlign: "center" }}>Face ID</th>
                                                                <th style={{ textAlign: "center" }}>Manual</th>
                                                                <th style={{ textAlign: "center" }}>QR</th>
                                                                <th style={{ textAlign: "center" }}>Face ID</th>
                                                            </tr>
                                                            {auditRows.map((r, idx) => {
                                                                const { startKey, endKey } = getStartEndKeys(r);
                                                                return (
                                                                    <Fragment key={idx}>
                                                                        {/* START row */}
                                                                        <tr>
                                                                            <td rowSpan={2} style={{ 'mso-number-format': '"\\@"' }}>
                                                                                {getFormattedRowDate(r).date}{'\u00A0'}{getFormattedRowDate(r).time}
                                                                            </td>
                                                                            <td rowSpan={2}>{getEmpNo(r)}</td>
                                                                            <td rowSpan={2}>{getEmpName(r)}</td>
                                                                            <td rowSpan={2}>{getJobCode(r)}</td>
                                                                            <td rowSpan={2}>{getWorkedDivision(r)}</td>
                                                                            <td rowSpan={2}>{getFieldName(r)}</td>
                                                                            <td rowSpan={2}>{getOperator(r)}</td>
                                                                            <td>Start</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'start', 'general_manual'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'start', 'general_qr'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'start', 'general_face'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'start', 'cash_manual'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'start', 'cash_qr'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'start', 'cash_face'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'start', 'overtime_manual'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'start', 'overtime_qr'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'start', 'overtime_face'))}</td>
                                                                        </tr>
                                                                        {/* COMPLETED row */}
                                                                        <tr>
                                                                            <td>Completed</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'completed', 'general_manual'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'completed', 'general_qr'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'completed', 'general_face'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'completed', 'cash_manual'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'completed', 'cash_qr'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'completed', 'cash_face'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'completed', 'overtime_manual'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'completed', 'overtime_qr'))}</td>
                                                                            <td style={{ textAlign: "center" }}>{getExcelTick(hasTick(r, 'completed', 'overtime_face'))}</td>
                                                                        </tr>
                                                                    </Fragment>
                                                                );
                                                            })}
                                                            <tr>
                                                                <th colSpan={8} style={{ textAlign: "center", fontWeight: "bold" }}>Capturing Percentages</th>
                                                                <th style={{ textAlign: "center" }}>{displayPercentages.general_manual}%</th>
                                                                <th style={{ textAlign: "center" }}>{displayPercentages.general_qr}%</th>
                                                                <th style={{ textAlign: "center" }}>{displayPercentages.general_face}%</th>
                                                                <th style={{ textAlign: "center" }}>{displayPercentages.cash_manual}%</th>
                                                                <th style={{ textAlign: "center" }}>{displayPercentages.cash_qr}%</th>
                                                                <th style={{ textAlign: "center" }}>{displayPercentages.cash_face}%</th>
                                                                <th style={{ textAlign: "center" }}>{displayPercentages.overtime_manual}%</th>
                                                                <th style={{ textAlign: "center" }}>{displayPercentages.overtime_qr}%</th>
                                                                <th style={{ textAlign: "center" }}>{displayPercentages.overtime_face}%</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <ReactHTMLTableToExcel
                                                        id="worker-captured-audit-excel-btn"
                                                        className="btn btn-primary pull-right ml-2"
                                                        table="worker-captured-audit-xls"
                                                        filename="WorkerCapturedAuditReportSundry"
                                                        sheet="Worker Captured Audit Report"
                                                        buttonText="Excel"
                                                    />
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}